import {initParentClick} from './helpers.js'

(function( $ ) {

	// document search
	let xhr = null;
	let timer = null;
	$( '.searchform.ajax' ).on( 'submit', function( e ) {
		e.preventDefault();
	} );
	$( '.searchform.ajax .form-control' ).on( 'keyup', function() {
		if ( timer !== null ) {
			clearTimeout( timer );
		}

		if ( xhr !== null ) {
			xhr.abort();
		}

		let self = this;
		let $form = $( this ).parents( '.searchform' );

		if ( self.value.length > 1 ) {
			let section = $( '.section-searchresults' );

			let results = section.find( '.overview-search' );
			let no_results = section.find( '.no-results' );
			let more = section.find( '.btn-dynamicmore' );
			let controller = $form.find( '[name=controller]' ).val();
			let action = 'acp_search';

			more.on( 'click', function( e ) {
				e.preventDefault();

				$( '.overview-search article' ).css( 'display', 'block' );
				more.hide();
			} );

			timer = setTimeout( function() {

				section.addClass( 'loading' );
				section.find( 'h2 > strong' ).text( self.value );

				more.hide();
				results.empty();
				no_results.hide();

				section.show();

				xhr = $.post( codepress.ajaxurl, {
					action : action,
					search : self.value,
					controller : controller,
				}, function( data ) {

					if ( data ) {
						results.html( data );
					} else {
						no_results.show();
					}

					if ( results.find( 'article' ).length > 4 ) {
						more.css( 'display', 'block' );
					}

					section.removeClass( 'loading' );
					initParentClick();
				} );

			}, 500 );
		}
	} );

	let $input = $( '.searchform .form-control' );
	if ( '' !== $input.val() ) {
		$input.trigger( 'keyup' );
	}

})( jQuery );
